import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/chrome': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M131.5 217.5L55.1 100.1C102.7 40.9 174.1 8.3 247.1 8 289.4 7.7 332.6 18.5 371.9 41.2 415.3 66.4 448.3 102.6 469.3 144.2L264 133.4C205.9 130 150.6 162.7 131.5 217.5zM164.4 256C164.4 302.2 201.8 339.6 248 339.6S331.6 302.2 331.6 256 294.2 172.4 248 172.4 164.4 209.7 164.4 256zM479.3 166.8L339.6 174C377.5 218.3 378.1 282.2 346.2 331.2L234.1 503.6C280.6 506.1 328.5 495.9 371.9 470.7 479.3 408.7 522.8 278.7 479.3 166.8zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256 0 380 90.8 482.7 209.5 500.9L273.2 376.1C215.6 386.9 160 355.3 133.7 303.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/chrome.js
// module id = r97w
// module chunks = 144